const PRODUCTS_DATA = [
    {
        id: "FlRn1RuaFfS4FsibuaaL", Category: "men", Color: "Black", FabricType: "Non Lycra", ProductName: "Black Washed Straight Fit Jeans", Description: "Elevate your style with Hack98’s Black Washed Straight Fit Jeans. Featuring a deep black wash with subtle faded highlights.", Minorder: 150, ProductCode: "H20LL", Sizes: ["26", "28", "30", "32", "34"], images: ["/images/0R4A9554.jpg", "/images/0R4A9555.jpg", "/images/0R4A9562.JPG", "/images/0R4A9563.JPG", "/images/0R4A9566.JPG"], mainImage: "/images/0R4A9554.jpg", Stock: "Available"
    },
    {
        id: "RB8a3K1gODUGGei2hnR6",
        Category: "men",
        Color: "Navy",
        FabricType: "Non Lycra",
        ProductName: "Vintage Wash Relaxed Fit Jeans",
        Description:
            "Step into effortless style with Hack98’s Vintage Wash Relaxed Fit Jeans. Featuring a deep blue tone with faded highlights, this pair delivers a rugged yet versatile look. Designed with a roomy fit for all-day comfort, perfect for casual outings and streetwear vibes.",
        Minorder: 200,
        ProductCode: "JE23LL",
        Sizes: ["26", "28", "30", "32", "34", "36"],
        images: [
            "/images/0R4A9506.jpg",
            "/images/0R4A9507.jpg",
            "/images/0R4A9512.jpg",
            "/images/0R4A9516.jpg",
            "/images/0R4A9520.jpg"
        ],
        mainImage: "/images/0R4A9506.jpg",
        Stock: "Available"
    },
    {
        id: "Xtr1fIA38yFlo5IMmCpR",
        Category: "men",
        Color: "Dark Blue",
        FabricType: "Non Lycra",
        ProductName: "Indigo Slim Fit Jeans",
        Description:
            "Elevate your everyday look with the Hack98 Indigo Slim Fit Jeans, crafted from premium stretch denim for ultimate comfort and durability.",
        Minorder: 149,
        ProductCode: "HE20LO",
        Sizes: ["26", "28", "30", "32", "34"],
        images: [
            "/images/0R4A9466.jpg",
            "/images/0R4A9470.jpg",
            "/images/0R4A9474.jpg",
            "/images/0R4A9476.jpg",
            "/images/0R4A9480.jpg"
        ],
        mainImage: "/images/0R4A9466.jpg",
        Stock: "Available"
    },
    {
        id: "ebLnnn0l1ILN5gD2khtA",
        Category: "men",
        Color: "Light Blue",
        FabricType: "Non Lycra",
        ProductName: "Light Blue Distressed Relaxed Fit Jeans",
        Description: "Make a bold statement with Hack98’s Light Blue Distressed Relaxed Fit Jeans. Featuring a washed-out light blue tone with rugged distressed details, this pair combines street-style edge with everyday comfort. Designed for a relaxed fit, it’s the ideal denim for casual outings and urban looks.",
        Minorder: 150,
        ProductCode: "202k",
        Sizes: ["26", "28", "30", "32", "34"],
        images: [
            "/images/0R4A9534.jpg",
            "/images/0R4A9541.jpg",
            "/images/0R4A9530.jpg",
            "/images/0R4A9544.jpg",
            "/images/0R4A9546.jpg"
        ],
        mainImage: "/images/0R4A9534.jpg",
        Stock: "Available"
    },
    {
        id: "f87F2xQPXRfT2OwO9t62",
        Category: "men",
        Color: "Light Blue",
        FabricType: "Non Lycra",
        ProductName: "Light Wash Straight Fit Jeans",
        Description: "A timeless classic, these jeans feature a straight-leg cut with a relaxed mid-rise waist. The light wash with faded accents adds a vintage edge, ideal for everyday wear.",
        Minorder: "151",
        ProductCode: "DDFY456G",
        Sizes: ["26", "28", "30", "32", "34"],
        images: [
            "/images/0R4A9488.jpg",
            "/images/0R4A9499.jpg",
            "/images/0R4A9491.jpg",
            "/images/0R4A9493.jpg",
            "/images/0R4A9505.jpg"
        ],
        mainImage: "/images/0R4A9488.jpg",
        Stock: "Available"
    },
    {
        id: "jCY0CfCXcV2KgbH580kO",
        Category: "men",
        Color: "Dark Blue",
        FabricType: "Non Lycra",
        ProductName: "Dark Blue Faded Straight Fit Jeans",
        Description: "Hack98 presents Dark Blue Faded Straight Fit Jeans, designed with whisker patterns and a vintage-inspired wash for a rugged yet stylish appeal. The straight fit ensures all-day comfort, making it perfect for casual outings or everyday wear.",
        Minorder: "150",
        ProductCode: "AC23F",
        Sizes: ["26", "28", "30", "32", "34", "36"],
        images: [
            "/images/0R4A9606.JPG",
            "/images/0R4A9614.JPG",
            "/images/0R4A9609.JPG",
            "/images/0R4A9610.JPG",
            "/images/0R4A9612.JPG",
        ],
        mainImage: "/images/0R4A9606.JPG",
        Stock: "Available"
    },
    {
        id: "pRK46iudySfc2cyUPtcj",
        Category: "men",
        Color: "Light Blue",
        FabricType: "Non Lycra",
        ProductName: "Light Blue Distressed Straight Fit Jeans",
        Description: "Step into casual style with Hack98’s Light Blue Distressed Straight Fit Jeans. Designed with a faded wash and subtle distressed detailing, these jeans bring a modern edge to your everyday look. The straight fit provides comfort and versatility, making them a great choice for both day and night wear.",
        Minorder: "150",
        ProductCode: "HE4LO",
        Sizes: ["24", "26", "28", "30", "32"],
        images: [
            "/images/0R4A9571.JPG",
            "/images/0R4A9580.JPG",
            "/images/0R4A9573.JPG",
            "/images/0R4A9574.JPG",
            "/images/0R4A9584.JPG",

        ],
        mainImage: "/images/0R4A9571.JPG",
        Stock: "Available"
    }

];

export default PRODUCTS_DATA;